export enum LanguageTestSubmissionStep {
  LOCKED = 'LOCKED',
  CHECKING_ACTIVE_SUBMISSION = 'CHECKING_ACTIVE_SUBMISSION',
  DISPLAY_INSTRUCTIONS = 'DISPLAY_INSTRUCTIONS',
  DISPLAY_TEST_SECTION = 'DISPLAY_TEST_SECTION',
  TEST_SUBMITTED = 'TEST_SUBMITTED'
}
